/// <amd-module name="Widgets/Configs/TeamWidgetConfig/index" />
export * from "./TeamWidgetConfig";
